import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import KnowledgeBaseSection from "../../Sections/Knowledgebase/index";

const KnowledgeBaseComponent = () => {
  return <Dashboard sectionName={<KnowledgeBaseSection />} />;
};

export default KnowledgeBaseComponent;
